import { connect } from 'react-redux';
import { Schedule as ScheduleComponent } from './schedule.component';
import { setOrders } from '../orders/orders.container';

// Wire setOrders so the Schedule screen can push the selected day's orders into
// the persisted `order.orders` slice the Chrome extension reads (card #101).
export const Schedule = connect(sState => ({ sState }), { setOrders })(ScheduleComponent);